import { Button, Checkbox, Divider, Space } from "antd";
import styles from "./style.module.css";

type FilterBoxType = {
  option: any[];
  handleChange: any;
  values: any[];
  clearFilter: any;
  onFilter: any;
};

const FilterBox = ({
  option,
  handleChange,
  values,
  clearFilter,
  onFilter
}: FilterBoxType): JSX.Element => {
  return (
    <div className={["student-list-checkbox", styles["checkbox-container"]].join(" ")}>
      <Checkbox.Group
        className={styles["width-100"]}
        options={option}
        onChange={handleChange}
        value={values}
      ></Checkbox.Group>
      <Divider style={{ marginBottom: "5px" }} />
      <Space style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          type="link"
          className={styles["clear-btn"]}
          aria-label="Clear all filters"
          onClick={clearFilter}
        >
          Clear all
        </Button>
        <Button
          type="primary"
          className={styles["apply-btn"]}
          aria-label="Apply selected filters"
          onClick={onFilter}
        >
          Apply
        </Button>
      </Space>
    </div>
  );
};

export default FilterBox;
